import { Link } from "react-router-dom";

// Utils and Constants
import { constructRedirectPath } from "../../utils/redirect-utils/RedirectUtils";
import { UrlKeys } from "../../constants/GeneralConstants";
import { useUrlKeyCheck } from "../../mavin/utils/hooks/HooksUtil";
import { getUpdatedCityName } from "../../common-utils/city-utils/CityUtils";

function CampaignSidebarItems({ citySelected, cityInfo, redirectLinkObj }) {
  const { cityId, cityName, mediaCount } = cityInfo;

  // checking is Prooh/Toohl Org
  // updating cityName (eg: Greater Mumbai => Mumbai)
  const isToohlSpecific = useUrlKeyCheck(UrlKeys.toohlSpecific);
  const updatedCityName = getUpdatedCityName(cityId, cityName);

  // City Name
  const finalCityName = isToohlSpecific ? updatedCityName : cityName;

  return (
    <li
      key={`sb-${cityId}`}
      className={`nav-item ${citySelected?.cityId === cityId ? "active" : ""}`}
    >
      <Link
        className="nav-link"
        to={constructRedirectPath(
          redirectLinkObj?.citySummaryLink.replace(":cityId", cityId)
        )}
      >
        {finalCityName} ({mediaCount})
      </Link>
    </li>
  );
}

/**
 * Component SIDEBAR
 */
function CampaignSidebar(props) {
  const {
    campaign,
    citySelected,
    redirectLinkObj = {},
    isHideOverview = false,
  } = props || {};
  const infoByCity = campaign.infoByCity || {};

  // hide overview link
  const hideOverviewLinkClass = isHideOverview ? "d-none" : "";

  return (
    <aside className="sidebar bg-alt">
      <ul className="nav flex-column mt-4">
        <li className={`nav-item ${!citySelected ? "active" : ""} `}>
          <Link
            className={`nav-link ${hideOverviewLinkClass}`}
            to={constructRedirectPath(redirectLinkObj?.campaignOverviewLink)}
          >
            Overview ({campaign.mediaCount})
          </Link>
        </li>

        {/* Cities Listing Section */}
        {Object.values(infoByCity).map((cityInfo, i) => (
          <CampaignSidebarItems
            key={i}
            citySelected={citySelected}
            cityInfo={cityInfo}
            redirectLinkObj={redirectLinkObj}
          />
        ))}
      </ul>
    </aside>
  );
}

export default CampaignSidebar;
